<template>
	<div style="width: 100%;">
		<div
			style="width: 210px;padding-top: 9px;padding-bottom: 9px;font-size: 14px;margin: auto;text-align: center;background-color: #aaa7a7;border-radius: 10px 10px 0px 0px;border-bottom: solid 1px #c6c6c6;">
			{{selectdItem.compontChildren[0].name + '设置'}}
		</div>
		<el-select filterable  v-loading="loading" style="margin:6px" size="small" v-model="classfiyValue" placeholder="请选择分类数据"
			@change="changeSelectClassfiy">
			<el-option v-for="classfiyItem in classfiy" :key="classfiyItem.id" :label="classfiyItem.description.name"
				:value="classfiyItem.id">
			</el-option>
		</el-select>

		<el-tabs v-model="editableTabsValue" :addable="false" :closable="true" type="card" @edit="handleTabsEdit">
			<el-tab-pane :key="item.classfiyId" v-for="(item, index) in compont.data.classfiy"
				:label="item.classfiyName" :name="item.classfiyId">
				<div style="display: flex;align-items: center;margin: 6px;">
					<div style="width: 120px;">最多显示</div>
					<el-input @input="()=>{selectdItem.compontChildren[0].layoutConfig.reLoad = true}" size="small"
						style="margin-left: 6px;" v-model="item.num" placeholder="请输入内容"></el-input>
				</div>
			</el-tab-pane>
		</el-tabs>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">显示风格</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.type = 'tab';selectdItem.compontChildren[0].layoutConfig.reLoad = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.type == 'tab'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.type == 'tab'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.type == 'tab'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">标签</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.type = 'block';selectdItem.compontChildren[0].layoutConfig.reLoad = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.type == 'block'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.type == 'block'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.type == 'block'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">区块</span>
				</div>
				<!-- <div @click="selectdItem.compontChildren[0].layoutConfig.type = 'list';selectdItem.compontChildren[0].layoutConfig.reLoad = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.type == 'list'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.type == 'list'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.type == 'list'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">列表</span>
				</div> -->
			</div>
		</div>

		<div style="margin-left: 6px;">标题主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.titleFamily" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.selectColor"
				style="margin-left: 3px;"></el-color-picker>
			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.titleSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.titleSize = e}"></wm-input-number>
			</div>
		</div>

		<!-- <div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">选中颜色</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.selectColor"
				style="margin-left: 3px;"></el-color-picker>
		</div> -->
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">未选中颜色</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.noSelectColor"
				style="margin-left: 3px;"></el-color-picker>
		</div>
		<!-- <div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">悬停颜色</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.hoverColor"
				style="margin-left: 3px;"></el-color-picker>
		</div> -->
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">商品设置跟随分类</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.followClassfiy = true;followClassfiyfun()"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.followClassfiy?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.followClassfiy?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.followClassfiy?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.followClassfiy = false;"
					:style="{backgroundColor:!selectdItem.compontChildren[0].layoutConfig.followClassfiy?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.followClassfiy?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.followClassfiy?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		<goods-tool v-if="!selectdItem.compontChildren[0].layoutConfig.followClassfiy"
			:fontFamilyName="systemFontFamilyName" v-bind="$props"></goods-tool>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import wmInputNumber from '../components/inputNumber.vue'
	import goodsTool from './goodsTool.vue'
	import lodash from 'lodash';
	import {
		getCategories,
		getDesignProducts,
		getAutocomplete
	} from '../../api/all.js'
	export default {
		components: {
			goodsTool,
			wmInputNumber
		},
		props: {
			all_setting: {
				type: Array,
				default: []
			},
			fontList: {
				type: Array,
				default: []
			},
			equipment: {
				type: String,
				default: "pc"
			},
			compontentStyle: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				editableTabsValue: "",
				editableTabs: [],
				loading: false,
				classfiyValue: "",
				classfiy: [],
			}
		},


		watch: {},


		computed: {
			...mapState("lowCodeStore", ['goodsConfig']),
			compont: function() {
				return this.selectdItem.compontChildren[0]
			},
			systemFontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			},

			fontFamilyName: function() {
				if (this.all_setting.length > 0) {
					return this.all_setting[0].tabList[1].config.setfontFamily.name
				} else {
					return ''
				}
			}
		},
		mounted() {
			console.log('this.fontFamilyName', this.fontFamilyName)
			
			
			
			
			this.selectdItem.compontChildren[0].layoutConfig.titleFamily = this.selectdItem.compontChildren[0].layoutConfig
				.titleFamily != '' ? this.selectdItem.compontChildren[0].layoutConfig.titleFamily : this.fontFamilyName

			this.getCategoriesData()
			if (this.compont.data.classfiy.length > 0) {
				this.editableTabsValue = this.compont.data.classfiy[0].classfiyId
			}
		},
		methods: {
			followClassfiyfun() {
				console.log('goodsConfiggoodsConfiggoodsConfig', this.goodsConfig)
				if (this.goodsConfig.length > 0) {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig = lodash.cloneDeep(this.goodsConfig[0]) 
					this.$forceUpdate()
				} else {
					this.selectdItem.compontChildren[0].layoutConfig.followClassfiy = false
					this.$message.error('未配置商品分类商品设置')
				}
				// this.selectdItem.compontChildren[0].layoutConfig.
			},
			handleTabsEdit(e) {
				console.log('handleTabsEdit', e)
				let i = -1
				console.log('this.compont.data.classfiy', this.compont.data.classfiy)
				this.compont.data.classfiy.forEach((item, index) => {
					if (item.classfiyId == e) {
						i = index
					}
				})
				
				console.log('handleTabsEdit', i)
				
				if(i != -1){
					this.compont.data.classfiy.splice(i, 1)
				}
			},
			async getCategoriesData() {
				let wsid = this.$cookies.get("wsid")
				let data = await getCategories({
					wsid
				})
				this.classfiy = data.data.data
				console.log('datadatadata', data)
			},
			async changeSelectClassfiy(e) {
				console.log('changeSelectClassfiy', e)
				try {
					
					
					
					let wsid = this.$cookies.get("wsid")
					this.loading = true
					// 如果存在不添加
					let exits = false
					let classfiyName = ""
					let classfiyLang = ""
					this.classfiy.forEach(item => {
						if (item.id == e) {
							classfiyName = item.description.name
							if(item.description.lang){
								classfiyLang = item.description.lang
							}
						}
					})
					this.compont.data.classfiy.forEach(item => {
						if ((item.classfiyId + '') == (e + '')) {
							exits = true
						}
					})
					
					if (exits) {
						this.loading = false
						return
					}
					
					// let products = await getDesignProducts({
					// 	wsid,
					// 	id: e,
					// 	name: classfiyName
					// })

					this.compont.data.classfiy.push({
						classfiyName,
						classfiyLang,
						classfiyId: e + '',
						num: 20,
					})
					if(this.selectdItem.compontChildren[0].layoutConfig.type == 'block'){
						this.selectdItem.compontChildren[0].layoutConfig.reLoad = true
					}
					this.editableTabsValue = e + ''
					this.loading = false
				} catch (e) {
					console.log('e', e)
					this.loading = false
				}
			},

		}
	}
</script>

<style scoped lang="scss">
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 6px;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>